import React from 'react';
import { Grid, Box, Skeleton } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  draggableContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  dragIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.disabled,
  },
}));

const AddressFieldsSkeleton = () => {
  const classes = useStyles();

  return (
    <Grid item xs={12} md={3}>
      <Skeleton variant="text" width={120} height={30} />
      <Box>
        {Array.from({ length: 13 }).map((_, idx) => (
          <Box key={idx} className={classes.draggableContainer}>
            <DragIndicatorIcon className={classes.dragIcon} />
            <Skeleton variant="rectangular" height={40} width="100%" />
          </Box>
        ))}
      </Box>
    </Grid>
  );
};

export default AddressFieldsSkeleton;